import { Router } from '@angular/router';
import { Chart } from 'chart.js';
import * as SecureLS from 'c1-vs-secure-ls';
import { ITab, ITabGroup, IAseguradoGroup, IAsegurado } from '../Entities/entities';

const secureLs = new SecureLS({
  encodingType: 'des',
  encryptionSecret: '6sDd90ddHQz#tj$[V9@>tR}y#Pb-oE',
});

export function getFullRut(rut: string) {
  return rut.split('-').join('');
}

export function getPureRut(rut: string) {
  return rut.split('-')[0];
}

export function getRutDigit(rut: string) {
  return rut.split('-')[1];
}

export function getRut(rut: string) {
  return rut.split('.').join('');
}

export function downloadPdf(content, fileName) {
  if (!content) {
    return;
  } 
  if (window.navigator.msSaveBlob) {
    const byteCharacters = atob(content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }
  const pdf = `data:application/octet-stream;charset=utf-16le;base64,${encodeURIComponent(
    content
  )}`;
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.setAttribute('style', 'display: none');
  a.href = pdf;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(pdf);
  a.remove();
}

export function findInObjectByField<T>(object: T, key: string): T {
  let value;
  Object.keys(object).some(k => {
    if (k === key) {
      value = object[k];
      return true;
    }
    if (object[k] && typeof object[k] === 'object') {
      value = findInObjectByField(object[k], key);
      return value !== undefined;
    }
  });
  return value;
}

export function isNumberColumn(datos: [any], columnName: string): boolean {
  const value = datos.find(d => d[columnName]);
  if (!value) {
    return false;
  }
  return !isNaN(Number(value[columnName]));
}

export function preparePrint(router: Router, data: any) {
  const storageData = localStorage.getItem('printdata');
  let printdata = {};
  let newkey = '1';
  if (storageData != null) {
    printdata = JSON.parse(storageData);
    const keys = Object.keys(printdata);
    if (keys.length > 0) {
      newkey = Object.keys(printdata).reduce((acc, x) =>
        parseInt(acc, 10) > parseInt(x, 10) ? acc : x
      );
    }
  }
  printdata[newkey] = data;
  localStorage.setItem('printdata', JSON.stringify(printdata));

  const url = router.createUrlTree(['/print', newkey]);
  const newWindow = window.open(url.toString(), '_blank');
  newWindow.opener = null;
}

export function getArraySumByField<T>(arr: T[], field: string) {
  if (!arr || arr.length === 0) {
    return 0;
  }
  return arr.reduce((sum, item) => sum + parseFloat(item[field]), 0);
}

export function getprimaenexceso<IAseguradoGroup>(arr: IAsegurado[], field: string) {
  if (!arr || arr.length === 0) {
    return 0;
  }
  for (var j=0 ;j<arr.length; j++){
    if(arr[j].Cobertura === 'PRIMA EN EXCESO'){
      arr[j].Cobertura = 'PRIMA EN EXCESO' + ' <svg-icon title="Prima en exceso a la prima periódica, opcional, que el contratante puede pagar en cualquier momento para aumentar su Valor póliza."  _ngcontent-c48="" class="icon ng-star-inserted" position="right" src="../../assets/icons/information-right-white.svg" ng-reflect-src="../../assets/icons/information" ng-reflect-svg-style="[object Object]" ng-reflect-text="Componente de la prima total pagada que se destina a ahorro." ng-reflect-position="right" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12.172" height="11.299" viewBox="0 0 12.172 11.299" style="width: 0.93rem; height: 0.87rem; position: relative; left: 0.15rem;"><defs><style>.cls-5{fill:#FFFFFF; stroke:#88849e}</style></defs><g id="information" transform="translate(0.15 0.15)"><g id="Grupo_1039" data-name="Grupo 1039" transform="translate(4.362 1.647)"><g id="Grupo_1038" data-name="Grupo 1038"><path class="cls-5" id="Trazado_183" data-name="Trazado 183" d="M212.4,90.255a1.305,1.305,0,0,0-.984-.407,1.375,1.375,0,0,0-1.406,1.075.939.939,0,0,0,.237.741,1.3,1.3,0,0,0,.975.4,1.362,1.362,0,0,0,1.415-1.074A.93.93,0,0,0,212.4,90.255Zm-.329.668a.818.818,0,0,1-.849.57.739.739,0,0,1-.549-.209.366.366,0,0,1-.1-.3.824.824,0,0,1,.84-.571.749.749,0,0,1,.558.216A.366.366,0,0,1,212.076,90.923Z" transform="translate(-210.008 -89.848)" fill="#fff" stroke="#fff" stroke-width="0.3"></path></g></g><g id="Grupo_1041" data-name="Grupo 1041" transform="translate(4.665 4.152)"><g id="Grupo_1040" data-name="Grupo 1040" transform="translate(0)"><path class="cls-5" id="Trazado_184" data-name="Trazado 184" d="M192.843,201.856c-.071-.048-.238-.16-.1-.936l.038-.177c.048-.222.137-.634.233-1.094v0a1.535,1.535,0,0,0-.226-1.258,1.347,1.347,0,0,0-.991-.507,1.661,1.661,0,0,0-1.459.681.353.353,0,0,0-.013.355.454.454,0,0,0,.15.155c.07.05.234.166.078.941-.015.071-.232,1.176-.261,1.332v0a1.515,1.515,0,0,0,.259,1.251,1.414,1.414,0,0,0,1.079.483,1.659,1.659,0,0,0,1.366-.721.353.353,0,0,0,0-.355A.453.453,0,0,0,192.843,201.856Zm-.39-2.322c-.1.458-.185.869-.232,1.089-.032.15-.039.181-.041.193v0c-.145.832,0,1.2.209,1.4a1.12,1.12,0,0,1-.23.155,1.17,1.17,0,0,1-.574.139.778.778,0,0,1-.589-.268.988.988,0,0,1-.143-.8c.031-.169.249-1.274.258-1.318v0c.166-.828.03-1.2-.172-1.4a1.121,1.121,0,0,1,.234-.149,1.171,1.171,0,0,1,.578-.123.778.778,0,0,1,.582.283A.988.988,0,0,1,192.453,199.533Z" transform="translate(-190.258 -197.876)" fill="#fff" stroke="#fff" stroke-width="0.3"></path></g></g><g id="Grupo_1043" data-name="Grupo 1043" transform="translate(0 0)"><g id="Grupo_1042" data-name="Grupo 1042" transform="translate(0 0)"><path class="cls-5" id="Trazado_185" data-name="Trazado 185" d="M1.215,27.524a5.092,5.092,0,0,1,.534-7.141A6.19,6.19,0,0,1,5.936,18.8a6.19,6.19,0,0,1,4.188,1.581,5.111,5.111,0,0,1,0,7.7,6.19,6.19,0,0,1-4.188,1.581,6.383,6.383,0,0,1-2.826-.654l-2.069.775a.285.285,0,0,1-.374-.345Zm1.813.907a.285.285,0,0,1,.232.014,5.8,5.8,0,0,0,2.676.647,5.138,5.138,0,0,0,5.366-4.86,5.138,5.138,0,0,0-5.366-4.861A5.138,5.138,0,0,0,.57,24.232a4.532,4.532,0,0,0,1.174,3.034.285.285,0,0,1,.06.267l-.434,1.519Z" transform="translate(0 -18.802)" fill="#fff" stroke="#fff" stroke-width="0.3"></path></g></g></g><rect></rect></svg></svg-icon>';
      }
  }
  return arr;
}

export function convertChartToImg(el: any) {
  const myLine = new Chart(el.nativeElement.getContext('2d'));
  return myLine.toBase64Image();
}

export function defaultSessionRefreshTime(storedToken) {
  return storedToken ? storedToken.expires_in / 2 : 150;
}

export function formateaRut(rut: string) {
  let rutPuntos = '';

  if (rut) {
    const actual = rut.replace(/^0+/, '');

    if (actual !== '' && actual.length > 1) {
      const sinPuntos = actual.replace(/\./g, '');
      const actualLimpio = sinPuntos.replace(/-/g, '');
      const inicio = actualLimpio.substring(0, actualLimpio.length - 1);
      let i = 0;
      let j = 1;
      for (i = inicio.length - 1; i >= 0; i--) {
        const letra = inicio.charAt(i);
        rutPuntos = letra + rutPuntos;
        if (j % 3 === 0 && j <= inicio.length - 1) {
          rutPuntos = '.' + rutPuntos;
        }
        j++;
      }
      const dv = actualLimpio.substring(actualLimpio.length - 1);
      rutPuntos = rutPuntos + '-' + dv;
    }
  } else {
    rutPuntos = '-';
  }
  return rutPuntos;
}

export function getTabIndexByTabName(tab: ITabGroup, tabName: string): ITab {
  return tab.tabs.find(x => x.tabName === tabName);
}

export function getLocalStorage(key: string) {


  return secureLs.get(key);
}

export function setLocalStorage(key: string, data: any) {
 
  secureLs.set(key, data);
}

export function removeLocalStorage(key: string) {
  localStorage.removeItem(key);
}

export function validaRut(rutCompleto: string, empresa?: boolean) {
  while (rutCompleto.includes('.')) {
    rutCompleto = rutCompleto.replace('.', '');
  }
  while (rutCompleto.includes('-')) {
    rutCompleto = rutCompleto.replace('-', '');
  }
  let dv = '';
  let rut = 0;

  if (rutCompleto.length === 8) {
    rutCompleto = 0 + rutCompleto;
  }
  if (rutCompleto.length !== 9) {
    return false;
  }

  rut = parseInt(rutCompleto.substring(rutCompleto.length - 1, -1), 10);
  dv = rutCompleto.charAt(rutCompleto.length - 1);

  if (dv === 'k') {
    dv = 'K';
  }

  if (isNaN(rut)) {
    return false;
  }
  if (!empresa && rut > 50000000) {
    return false;
  } else if (empresa && rut < 50000000) {
    return false;
  }

  if (!revisa_DV(rut, dv)) {
    return false;
  }
  return true;
}

export function revisa_DV(a: number, b: string) {
  if (a === null || b === null) {
    return false;
  }
  let s = 0;
  let m = 2;
  let d = '0';
  let e = 0;
  for (let i = a.toString().length - 1; i >= 0; i--) {
    s = s + parseInt(a.toString().charAt(i), 10) * m;
    if (m === 7) {
      m = 2;
    } else {
      m++;
    }
  }
  const r = s % 11;
  if (r === 1) {
    d = 'K';
  } else {
    if (r === 0) {
      d = '0';
    } else {
      e = 11 - r;
      d = e + '';
    }
  }
  console.log('DV Parámetro:', b);
  console.log('DV obtenido:', d);
  if (b !== d) {
    return false;
  }
  return true;
}

export function validaCorreo(correo: string) {
  if (
    !Array.isArray(
      correo.toLocaleLowerCase().match(
    
        /^[a-z0-9!#$&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
      )
    )
  ) {
    return false;
  }

  return true;
}
